<template>
  <div>
    <hr-text-field
      :model-value="link"
      :label="$t('common.modals.copyLink.inputLinkLabel')"
      readonly
      hide-bottom-space
      data-e2e="text-copy-link"
      @focus="$event.target.select()"
      @click="$event.currentTarget.querySelector('input')?.select()"
    >
      <template #append>
        <hr-icon-action-btn
          icon="content_copy"
          :aria-label="$t('common.modals.copyLink.buttonCopy')"
          @click="copyToClipboard"
        />
      </template>
    </hr-text-field>
  </div>
</template>

<script>
import { Clipboard } from '@capacitor/clipboard';
import { copyToClipboard } from 'quasar';
import { notifySuccess } from 'src/composables/interactions';
import { HrIconActionBtn, HrTextField } from 'src/design-system';

export default {
  name: 'CopyLink',

  components: {
    HrIconActionBtn,
    HrTextField,
  },

  props: {

    link: {
      type: String,
      required: true,
    },
  },

  methods: {
    async copyToClipboard() {
      if (this.$q.platform.is.capacitor) {
        await Clipboard.write({
          url: this.link,
        });
      } else {
        await copyToClipboard(this.link);
      }

      notifySuccess(this.$t('common.modals.copyLink.successMessage'));
    },
  },
};
</script>
